'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	MIN_FONT_SIZE = 5,
	MAX_FONT_SIZE = 40,
	FONT_MULTIPLIER = 1.1;
mmWidgets.fn.themeStyleFontSizeWidget = function (mapThemeModel) {
	const getCurrentSize = (themeNodeStyle) => {
			const fontSize = mapThemeModel.getThemeAttribute(['node'], [themeNodeStyle, 'default'], ['text', 'font', 'size']);
			return parseFloat(fontSize);
		},
		setSize = (themeNodeStyle, size) => {
			const sizePx = (size * 1.33) || undefined;
			mapThemeModel.overrideThemeAttribute(['node', themeNodeStyle, 'text', 'font', 'size'], size || undefined);
			mapThemeModel.overrideThemeAttribute(['node', themeNodeStyle, 'text', 'font', 'sizePx'], sizePx);
		},
		multiplyFontSize = (themeNodeStyle, multiple) => {
			const current = getCurrentSize(themeNodeStyle),
				newSize = current * multiple;

			if (newSize < MIN_FONT_SIZE) {
				setSize(themeNodeStyle, MIN_FONT_SIZE);
			} else if (newSize > MAX_FONT_SIZE) {
				setSize(themeNodeStyle, MAX_FONT_SIZE);
			} else {
				setSize(themeNodeStyle, newSize);
			}
		},
		increment = function (themeNodeStyle) {
			multiplyFontSize(themeNodeStyle, FONT_MULTIPLIER);
		},
		decrement = function (themeNodeStyle) {
			multiplyFontSize(themeNodeStyle, 1 / FONT_MULTIPLIER);
		},
		reset = (themeNodeStyle) => {
			setSize(themeNodeStyle, 0);
		},
		actions = {increment, decrement, reset};

	return mmWidgets.each(this, function () {
		const widget = this;
		widget.click(() => {
			const themeNodeStyle = widget.attr('data-mm-theme-node-style'),
				operation = widget.attr('data-mm-font-size');

			actions[operation](themeNodeStyle);
		});
	});
};

